/*! @license Firebase v3.7.6
Build: rev-d1c8cec
Terms: https://firebase.google.com/terms/ */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.patchProperty = patchProperty;
function deepCopy(value) {
    return deepExtend(undefined, value);
}
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            return new Date(source.getTime());

        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            target = [];
            break;
        default:
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}



//////////////////
// WEBPACK FOOTER
// ./~/firebase/app/deep_copy.js
// module id = 380
// module chunks = 2